import { apiSlice } from './apiSlice';
const DEPOSITS_URL = '/api/deposits';


export const depositsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDeposits: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: DEPOSITS_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Deposits'],
    }),
    getDepositDetails: builder.query({
      query: (depositId) => ({
        url: `${DEPOSITS_URL}/${depositId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    createDeposit: builder.mutation({
      query: (depositData) => ({
        url: DEPOSITS_URL,
        method: 'POST',
        body: depositData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Deposits'],
    }),
    updateDeposit: builder.mutation({
      query: ({ depositId, ...data }) => ({
        url: `${DEPOSITS_URL}/${depositId}`,
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Deposits'],
    }),
    uploadDepositImages: builder.mutation({
      query: (formData) => ({
        url: '/api/upload',
        method: 'POST',
        body: formData,
      }),
    }),
    deleteDeposit: builder.mutation({
      query: (depositId) => ({
        url: `${DEPOSITS_URL}/${depositId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Deposits'],
    }),
    createReview: builder.mutation({
      query: ({ depositId, ...data }) => ({
        url: `${DEPOSITS_URL}/${depositId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Deposits'],
    }),
    getTopDeposits: builder.query({
      query: () => `${DEPOSITS_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGetDepositsQuery,
  useGetDepositDetailsQuery,
  useCreateDepositMutation,
  useUpdateDepositMutation,
  useUploadDepositImagesMutation,
  useDeleteDepositMutation,
  useCreateReviewMutation,
  useGetTopDepositsQuery,
} = depositsApiSlice;